import { ClockCircleOutlined } from '@ant-design/icons';

import { useT } from '../../../../i18n';
import { cn } from '../../../../lib/cn';
import { ngayVN } from '../../../../lib/dinh-dang';
import { NHAN_HAN, TONG_HAN } from '../../constants';
import { thongTinHan } from '../../nghiep-vu/nhiem-vu';
import type { NutNhiemVu } from '../../types-nhiem-vu';

export function DeadlineChip({ task }: { task: Pick<NutNhiemVu, 'deadline' | 'status'> }) {
  const { t } = useT();
  const { kind, days } = thongTinHan(task);
  const ngay = ngayVN(task.deadline);
  const gap = kind === 'overdue' || kind === 'today' || kind === 'soon';
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <span className={cn('inline-flex items-center gap-1 rounded text-xs font-medium', gap && 'px-1.5 py-0.5', TONG_HAN[kind])}>
        {gap && <ClockCircleOutlined aria-hidden />}
        {t(NHAN_HAN[kind], { so: days, ngay })}
      </span>
      {kind !== 'none' && kind !== 'done' && <span className="text-2xs tabular-nums text-content-muted">{ngay}</span>}
    </span>
  );
}
